import React, { useEffect, useState } from 'react';
import { ChromePicker } from 'react-color';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Chip,
} from '@mui/material';
import { toast } from 'react-toastify';
import ModelLPSignUp from '../../LandingPageSignUp/model';
import useForm from '../../Hooks/useForm';
import getAllRafflesOfPartner from 'js/library/utils/API/Draw/getAllRafflesOfPartner';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  overflowY: 'scroll',
  p: 4,
};

const DrawModal = ({ isActiveModals, closeModal, setPayload, selectedModalInfos }) => {
  const currentModal = ModelLPSignUp.modalsList.draw;
  const partnerId = localStorage.getItem('partnerIdClube');

  const [displayColorPicker, setDisplayColorPicker] = useState({
    colors: false,
    boxColor: false,
  });

  const [tempColor, setTempColor] = useState('#000');
  const [loading, setLoading] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [raffleIdentifiersList, setRaffleIdentifiersList] = useState([]);

  const { form, setForm, validateForm, clearForm } = useForm({
    colors: {
      value: [],
      required: false,
    },
    boxColor: {
      value: '',
      required: false,
    },
    raffleIdentifier: {
      value: '',
      required: true,
    },
  });

  const handleToggleColorPicker = (type) => {
    setDisplayColorPicker((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));

    if (type === 'colors') {
      setTempColor('#000');
    }
  };

  const handleAddColor = (color) => {
    if (form.colors.value.length >= 6) {
      toast.warning('Você pode adicionar no máximo 6 cores.');
      return;
    }

    setForm((prev) => ({
      ...prev,
      colors: {
        ...prev.colors,
        value: [...prev.colors.value, color],
      },
    }));
  };

  const handleRemoveColor = (index) => {
    setForm((prev) => ({
      ...prev,
      colors: {
        ...prev.colors,
        value: prev.colors.value.filter((_, i) => i !== index),
      },
    }));
  };

  // Busca os sorteios para ser usado no select
  useEffect(() => {
    (async function getRaffleIdentifier() {
      try {
        const result = await getAllRafflesOfPartner(partnerId);
        setRaffleIdentifiersList(result);
      } catch (err) {
        toast.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (isActiveModals) {
      const { colors, boxColor, raffleIdentifier } = selectedModalInfos?.modalInfos || {};

      setForm((prevState) => ({
        ...prevState,
        colors: {
          value: colors || [],
          required: false,
        },
        boxColor: {
          value: boxColor || '',
          required: false,
        },
        raffleIdentifier: {
          value: raffleIdentifier || '',
          required: true,
        },
      }));
    }
  }, [isActiveModals, selectedModalInfos, setForm]);

  const handleCloseModal = () => {
    clearForm();
    closeModal(currentModal);
  };

  const handleSave = () => {
    setLoadingSave(true);
    const { colors, boxColor, raffleIdentifier } = form;

    if (validateForm()) {
      setPayload((prevState) => {
        const modules = prevState.campaignLandpage.modules;
        modules[selectedModalInfos.currentIndex] = {
          ...selectedModalInfos.modalInfos,
          colors: colors.value,
          boxColor: boxColor.value,
          raffleIdentifier: raffleIdentifier.value,
        };
        return {
          campaignLandpage: {
            ...prevState?.campaignLandpage,
            modules,
          },
        };
      });
      toast.success('Sorteio salvo com sucesso!');
      clearForm();
      closeModal(currentModal);
    } else {
      toast.error('Preencha todos os campos obrigatórios!');
    }
  };

  return (
    <Modal open={isActiveModals}>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        flexDirection={'column'}
        alignItems={'center'}
        width={'100%'}
        maxHeight={'90vh'}
        maxWidth={'1000px'}
        bgcolor={'white'}
        borderRadius={'5px'}
        gap={'1rem'}
        sx={style}
      >
        {loading ? (
          <CircularProgress size={50} thickness={6} />
        ) : (
          <>
            {/* CORES DO SORTEIO */}
            <Box width={'100%'} display={'flex'} flexDirection={'column'} gap={'12px'}>
              <Box display={'flex'} alignItems={'center'} columnGap={'12px'}>
                <TextField
                  fullWidth
                  label="Cores do sorteio"
                  value=""
                  InputProps={{ readOnly: true }}
                />
                <Button
                  sx={{ minWidth: '10rem' }}
                  variant="contained"
                  onClick={() => handleToggleColorPicker('colors')}
                >
                  {displayColorPicker.colors ? 'Fechar' : 'Selecionar cor'}
                </Button>
              </Box>

              {displayColorPicker.colors && (
                <Box>
                  <ChromePicker color={tempColor} onChange={(color) => setTempColor(color.hex)} />
                  <Button
                    variant="contained"
                    sx={{ mt: 1 }}
                    onClick={() => {
                      handleAddColor(tempColor);
                    }}
                  >
                    Adicionar Cor
                  </Button>
                </Box>
              )}

              <Box display="flex" flexWrap="wrap" gap="8px">
                {form.colors.value.map((color, index) => (
                  <Chip
                    key={index}
                    label={color}
                    style={{ backgroundColor: color, color: '#fff' }}
                    onDelete={() => handleRemoveColor(index)}
                  />
                ))}
              </Box>
            </Box>

            {/* COR DA CAIXA */}
            <Box width={'100%'} display={'flex'} flexDirection={'column'} gap={'12px'}>
              <Box display={'flex'} alignItems={'center'} columnGap={'12px'}>
                <TextField
                  fullWidth
                  label="Cor da caixa de sorteados e ganhadores"
                  value={form.boxColor.value || ''}
                  InputProps={{ readOnly: true }}
                />
                <Button
                  sx={{ backgroundColor: form.boxColor.value || '#ccc', minWidth: '10rem' }}
                  variant="contained"
                  onClick={() => handleToggleColorPicker('boxColor')}
                >
                  {displayColorPicker.boxColor ? 'Salvar' : 'Selecionar cor'}
                </Button>
              </Box>

              {displayColorPicker.boxColor && (
                <ChromePicker
                  color={form.boxColor.value}
                  onChangeComplete={(color) =>
                    setForm((prev) => ({
                      ...prev,
                      boxColor: {
                        ...prev.boxColor,
                        value: color.hex,
                      },
                    }))
                  }
                />
              )}
            </Box>

            {/* SELECT DE IDENTIFICADOR */}
            <FormControl fullWidth>
              <InputLabel id="campaign-select-label">
                Selecione o identificador do sorteio
              </InputLabel>
              <Select
                labelId="campaign-select-label"
                value={form.raffleIdentifier.value}
                label="Selecione o identificador do sorteio"
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    raffleIdentifier: {
                      ...prev.raffleIdentifier,
                      value: e.target.value,
                    },
                  }))
                }
              >
                {raffleIdentifiersList.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {`Campanha: ${item.campaignId} | Identificador: ${item.id}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* BOTÕES */}
            <Box
              marginTop={'20px'}
              display={'flex'}
              alignItems={'center'}
              columnGap={'12px'}
              justifyContent={'center'}
              width={'100%'}
            >
              <Button
                disabled={loadingSave}
                variant="contained"
                color="primary"
                onClick={handleSave}
                sx={{ minWidth: '6rem' }}
              >
                {loadingSave ? <CircularProgress size={25} thickness={5} /> : 'Salvar'}
              </Button>

              <Button variant="contained" color="primary" onClick={handleCloseModal}>
                Cancelar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default DrawModal;
